import { bookingRoomLabel } from './bookingRoomLabel';
import { bookingGuestNameLabel } from './bookingGuestLabel';
import type { Booking } from '../types/booking';

// Compare telephone syntax only; guest messages are never parsed for meaning.
function phoneDigits(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (digits.startsWith('0049')) return `0${digits.slice(4)}`;
  if (digits.startsWith('49')) return `0${digits.slice(2)}`;
  return digits;
}

export function matchesBooking(booking: Booking, query: string): boolean {
  const term = query.trim().toLocaleLowerCase('de');
  if (!term) return false;
  const textFields = [bookingGuestNameLabel(booking), booking.bookingReference,
    booking.id, booking.ilocaId, booking.illocaInternalId, booking.otaReference,
    ...booking.references ?? [], ...Object.values(booking.referenceMap ?? {}),
    bookingRoomLabel(booking), booking.roomId];
  if (textFields.some(value => value != null && String(value).toLocaleLowerCase('de').includes(term))) return true;
  const digits = phoneDigits(term);
  // Only a telephone query is compared as digits; letters must not turn into an empty match.
  return digits.length > 0 && /^[+\d\s()./-]+$/.test(term) &&
    [booking.guestPhone, booking.primaryPhone, booking.guest?.phone, booking.guest?.primaryPhone]
      .some(value => value && phoneDigits(value).includes(digits));
}

export function bookingSearchWindow(today = new Date()): { dateFrom: string; dateTo: string } {
  const day = (offset: number) => {
    const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + offset);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };
  return { dateFrom: day(-30), dateTo: day(90) };
}
